import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import * as Objects from '@core/objects';
import { VersionShareItem } from '@core/models/version-share.model';

// Initialize the state (set access to feedbacks)
export const Init = createAction(
    '[ProjectRelatedVersions] INIT - Set the access to feedbacks', props<{ access: boolean }>());

// Load a single project for a project
export const SetProject = createAction(
    '[ProjectRelatedVersions] SET - Set the Project', props<{ project: Objects.Request }>());

// Load related projects for a project
export const LoadRelated = createAction(
    '[ProjectRelatedVersions] GET - Load Related Versions', props<{ project: Objects.Request }>());
export const LoadRelatedSuccess = createAction(
    '[ProjectRelatedVersions] GET - Load Related Versions Success', props<{ versions: Objects.Version[] }>());
export const LoadRelatedError = createAction(
    '[ProjectRelatedVersions] GET - Load Related Versions Failure', props<{ error: HttpErrorResponse }>());

// Load feedbacks for a project
export const LoadFeedbacks = createAction(
    '[ProjectRelatedVersions] GET - Load Related Versions Feedbacks', props<{ versions: Objects.Version[] }>());
export const LoadFeedbacksSuccess = createAction(
    '[ProjectRelatedVersions] GET - Load Related Versions Feedbacks Success', props<{ feedbacks: VersionShareItem[] }>());
export const LoadFeedbacksError = createAction(
    '[ProjectRelatedVersions] GET - Load Related Versions Feedbacks Failure', props<{ error: HttpErrorResponse }>());

// Clear / reset state
export const Clear = createAction(
    '[ProjectRelatedVersions] CLEAR - Clear Project Related Versions State');

